/**
 * Analytics Configuration
 * Configure which analytics services are enabled and their respective settings
 */

export type AnalyticsConfig = {
  mixpanel: {
    enabled: boolean;
    token: string;
    options?: {
      persistence?: string;
      track_pageview?: string;
      debug?: boolean;
      [key: string]: any;
    };
  };
};

// Get tokens from environment variables or use defaults
const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN || "6d1b622ddc2e82519d66801c2c7e84e4";

const analyticsConfig: AnalyticsConfig = {
  mixpanel: {
    enabled: true,
    token: MIXPANEL_TOKEN,
    options: {
      persistence: "localStorage",
      track_pageview: "url-with-path"
    }
  }
};

// Allow disabling analytics via environment variable
if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_ANALYTICS !== 'true') {
  analyticsConfig.mixpanel.enabled = false;
}

export default analyticsConfig;
